import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasInputAdornment = ({
  children,
  position,
  className,
  // eslint-disable-next-line no-unused-vars
  sx,
  ...props
}) => (
  <span className={cn('flex items-center text-text-secondary', position === 'start' ? 'pr-1' : 'pl-1', className)} {...props}>
    {children}
  </span>
)

AdasInputAdornment.propTypes = {
  children: PropTypes.node,
  position: PropTypes.oneOf(['start', 'end']),
  className: PropTypes.string
}
